import { Component, Inject, OnInit } from '@angular/core';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { GrievanceActionComponent } from '../grievance-action/grievance-action.component';
import { Location } from '@angular/common';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-complaint-form',
  templateUrl: './complaint-form.component.html',
  styleUrls: ['./complaint-form.component.scss']
})
export class ComplaintFormComponent implements OnInit {
  dialogRef: MatDialogRef<any>;
  complaintForm: FormGroup;
  submitpayload: any;
  isOtherChecked = false;
  selectedOption: string = '';
  Course: any;
  CoCode; any;
  address: any;
  city: any;
  session: any;
  state: any;
  pincode: any;
  departmentList: any;
  filterdepartmentList: any;
  statusList: any;
  filterstatusList: any;
  complaintList: any;
  data: any;
  GrievanceID: 0;
  StuloginID: 0;
  DepartmentID: 0;
  GrievanceTitle: any;
  GrievanceDescription: any;
  PreviousAttempt: any;
  PreviousAttemptDetail: any;
  StatusCode: any;
  actionList: any;
  actionCommentList: any;
  grivenceData;
  commentList: any;
  StuFullName: string;
  grievancestatus = false;
  // GrievanceClose: number;
  showUpdateButton: boolean = false;
  PreFix: any;
  formattedPrn: string;
  
  constructor(public umsService: UmsService,private spinner: NgxSpinnerService,
    private fb: FormBuilder,private modalPopupService: ModalpopService,private dialog: MatDialog,
    private route: ActivatedRoute, private location: Location,
    private datePipe: DatePipe,
  ) 
  { 
    // this.route.queryParams.subscribe(params => {
    //   this.grivenceData = params;
    //   // this.prepopulation(params)
    // });
  }
  InstuName
  RgNo
  StateCodeListC
  FirstName: string
  MiddleName: string
  LastName: string
  Number: number
  showOtherTextArea = false;
  messagee = '';
  msgshw = false;
  msgshw2 = false;
  StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
  actionFormArray;
  // convertUTCToIST(dateString: string): string {
  //   const utcDate = new Date(dateString); // Convert string to Date object
  //   const istDate = new Date(utcDate.getTime() - (330 * 60 * 1000)); // IST is UTC + 5:30
  //   return this.datePipe.transform(istDate, 'dd/MM/yyyy h:mm:ss a', 'Asia/Kolkata') || '';
  // }
  ngOnInit(): void {
    const state = history.state;
    this.grivenceData = state.data;
    if (!this.grivenceData) {
      this.grivenceData = JSON.parse(localStorage.getItem('grivenceData') || '{}');
    }
    this.prepopulation(this.grivenceData);
    this.StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
    this.getSecretData();
    this.getActionCommentData();
    this.loadsettingspage();
    this.stuAddDetails();
    this.getCourseData();
    this.getDepartment();
    this.fetchStatus();
    
    this.RgNo = this.grivenceData.LoginId;
    this.transPRN(this.RgNo)
    this.complaintForm = this.fb.group({
      GrievanceID: new FormControl (this.grivenceData.GrievanceID),
      StuloginID: new FormControl (this.grivenceData.StuloginID, [Validators.required]),
      GrievanceTitle: new FormControl (this.grivenceData.GrievanceTitle, [Validators.required]),
      GrievanceDescription: new FormControl (this.grivenceData.GrievanceDescription, [Validators.required]),
      StatusCode: new FormControl (this.grivenceData.StatusCode, [Validators.required]),
      DepartmentID: new FormControl ((this.grivenceData.DepartmentID), [Validators.required]),
      PreviousAttempt: new FormControl ((this.grivenceData.PreviousAttempt), [Validators.required]),
      PreviousAttemptDetail: new FormControl (this.grivenceData.PreviousAttemptDetail),
      UserID: new FormControl (this.grivenceData.UserID)
    });

  }

  getSecretData() {
    this.spinner.show();
    let payload = {};
    this.umsService.getSecretData().subscribe((res) => {
      this.spinner.hide();
      this.InstuName = res.projectPharam['InstituteName']
      this.session = res.projectPharam['SnName']
    })
  }
  transPRN(RgNo){
    let RgNo1 = 99999;
this.formattedPrn = RgNo.toString().padStart(8, '0');
  }

  getCourseData() {
    this.spinner.show();
    const payload = {};
    payload['CoCode'] = this.grivenceData.CoCode
    this.umsService.getCourse(payload).subscribe(res => {
      this.spinner.hide();
      this.PreFix = res.data[0]['CoRgPrfx']
    });
  }

  stuAddDetails() {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.grivenceData.StuloginID;
    this.umsService.fetchContactDetails(payload).subscribe((res) => {
      // this.spinner.hide();
      if (res.status) {
        this.address = res.data[0]['StuAddrC'];
        this.city = res.data[0]['StuCityC'];
        this.pincode = res.data[0]['StuPinC'];
        if (res.data.length > 0) {
          this.fetchStateC(res.data[0].StuCountryC, res.data[0].StuStateC);
        }
      } else {
        this.spinner.hide();
      }
    });
  }

  fetchStateC(CountryCode, StateCode) {
    // this.spinner.show();
    const payload = {};
    payload['CountryCode'] = CountryCode;
    this.umsService.getCountryWiseState(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        const stateData = res.data.find(state => state.StateCode === StateCode);
        if (stateData) {
          this.state = stateData.StateName;
        } 
      } 
    });
  }

  getDepartment() {
    const payload = {};
    this.umsService.getDepartment(payload).subscribe((res) => {
      if (res.status) {
        this.departmentList = res.data;
        this.filterdepartmentList = this.departmentList.slice();
      } else {
      }
    });
  }

  onDepartmentChange(value: string): void {
    this.showOtherTextArea = value === 'OTH'; 
  }

  UpdateComplaint() {
 
    this.spinner.show();
    this.submitpayload = this.complaintForm.value;
    let payload = {}
    payload['GrievanceID'] = this.submitpayload.GrievanceID
    payload['GrievanceTitle'] = this.submitpayload.GrievanceTitle
    payload['GrievanceDescription'] = this.submitpayload.GrievanceDescription
    payload['DepartmentID'] = this.submitpayload.DepartmentID
    payload['PreviousAttempt'] = this.submitpayload.PreviousAttempt
    payload['PreviousAttemptDetail'] = this.submitpayload.PreviousAttemptDetail
    payload['StatusCode'] = this.submitpayload.StatusCode
    payload['StuloginID'] = this.grivenceData.LoginId
    payload['UserID'] = this.grivenceData.UserID
    this.umsService.updateComplaint(payload).subscribe(res => {
      this.grievancestatus = true;
      this.spinner.hide();
      
      if (res.status) {
        let data = {}
        if (this.StatusCode === 'C') {
          data['message'] = "Grievance closed successfully"
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.dialogRef.afterClosed().subscribe((result) => {
            this.goBack();
          });
        } else {
          data['message'] = "Updated Successfully"
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.dialogRef.afterClosed().subscribe((result) => {
            this.goBack();
          });
        }
      }
      else {
      }

    },
    );
  }

  prepopulation(data) {
    this.complaintForm = this.fb.group({
      GrievanceID: new FormControl (data.GrievanceID),
      StuloginID: new FormControl (data.StuloginID, [Validators.required]),
      GrievanceTitle: new FormControl (data.GrievanceTitle, [Validators.required]),
      GrievanceDescription: new FormControl (data.GrievanceDescription, [Validators.required]),
      StatusCode: new FormControl (data.StatusCode, [Validators.required]),
      DepartmentID: new FormControl (data.DepartmentID, [Validators.required]),
      PreviousAttempt: new FormControl (data.PreviousAttempt, [Validators.required]),
      PreviousAttemptDetail: new FormControl (data.PreviousAttemptDetail),
      UserID: new FormControl (data.UserID),
    });
    if (data.StatusCode === 'C') {
      this.grievancestatus = true;
    }
  }

  onOptionChange(event: Event): void {
    const selectedOption = (event.target as HTMLInputElement).value;
    
    if (!selectedOption) {
      this.complaintForm.get('PreviousAttemptDetail').setValue('');
    }
  }

  fetchStatus() {
    const payload = {};
    payload['CdType'] = 'GS';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.statusList = res.data;
        this.filterstatusList = this.statusList.slice();
      } else {
      }
    });
  }
  getActionCommentData() {
    const payload = {};
    payload['GrievanceID'] = this.grivenceData.GrievanceID
    this.umsService.getActionComment(payload).subscribe(res => {
      if (res.status) {
        this.actionCommentList = res.data;
      } else {
      }
    },
  );
  }
 
    addnewrecord() {
    const dialogRef = this.dialog.open(GrievanceActionComponent, {
      width: '700px',
      data: { key: "New" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getActionCommentData();
    });
  }
  Back() {
    this.goBack();
  }
  goBack(): void {
    this.location.back(); // This will navigate back to the previous page
  }
  Close() {
    // this.showUpdateButton = true;
    const data = {};
    data['message'] = 'Are you sure you want to close this grievance?';
    data['title'] = 'Alert';
    data['icon'] = 'fa fa-question';
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.StatusCode = 'C'
      } else if (result === 'no') {
        this.StatusCode = 'O'
      }
    });

  }

  convertUTCToIST(dateString: string): string {
    const utcDate = new Date(dateString); // Convert string to Date object
    // Directly use the date pipe with 'Asia/Kolkata' time zone
    return this.datePipe.transform(utcDate, 'dd/MM/yyyy h:mm:ss a', 'Asia/Kolkata') || '';
  }
  loadsettingspage() {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'Grievance';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.spinner.hide()
      res.data.forEach((element) => {
        if (element.FormVisible) {
          // if (element.FormRequired) {
            // if (element.FormPattern == '') {
              this.complaintForm.addControl(element.FormControlName, new FormControl(''));
            } else {
              this.complaintForm.addControl(element.FormControlName, new FormControl(''));
            }
          // } 
          // else {
          //   if (element.FormPattern == '') {
          //     this.complaintForm.addControl(element.FormControlName, new FormControl(''));
          //   } else {
          //     this.complaintForm.addControl(element.FormControlName, new FormControl('', [Validators.pattern(element.FormPattern)]));
          //   }
          // }
        // }
      });
      this.actionFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }
}
